import { render, staticRenderFns } from "./monthlyOffers.vue?vue&type=template&id=1f1da564&scoped=true&"
import script from "./monthlyOffers.vue?vue&type=script&lang=js&"
export * from "./monthlyOffers.vue?vue&type=script&lang=js&"
import style0 from "./monthlyOffers.vue?vue&type=style&index=0&id=1f1da564&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1da564",
  null
  
)

export default component.exports